<div class="container">
  <h1 class="section-title">
    {{
      isEditMode ? 'Edit Component Credential' : 'Create Component Credential'
    }}
  </h1>

  <div class="loading" *ngIf="loading">Loading component credential...</div>

  <form
    *ngIf="!loading"
    [formGroup]="form"
    [noValidate]="true"
    (ngSubmit)="submit()"
  >
    <h2 class="section-sub-title">Credential Details</h2>

    <div class="form-column half-width">
      <div class="full-width">
        <app-autocomplete
          [data]="componentOptions"
          label="Component"
          [isRequired]="true"
          [preSelectedValue]="componentPreSelectedValue"
          propertyName="componentName"
          [formatterFn]="componentFormatter"
          (valueSelected)="onComponentSelected($event)"
        ></app-autocomplete>
        <span
          class="inline-error"
          *ngIf="
            componentIdControl.hasError('required') &&
            componentIdControl.touched
          "
        >
          Component is required.
        </span>
      </div>

      <div class="full-width">
        <app-autocomplete
          [data]="scopes"
          label="Scope"
          [clearable]="true"
          [preSelectedValue]="scopePreSelectedValue"
          propertyName="name"
          [formatterFn]="scopeFormatter"
          (valueSelected)="onScopeSelected($event)"
        ></app-autocomplete>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          class="input-filed"
          matInput
          formControlName="description"
          placeholder="Enter credential description"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>

    <h2 class="section-sub-title">Client Details</h2>
    <div class="form-column half-width">
      <mat-form-field appearance="outline">
        <mat-label>Client ID</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          formControlName="clientId"
          placeholder="Enter client ID"
        />
        <mat-error *ngIf="form.controls['clientId'].hasError('required')">
          Client ID is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Client Secret</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          formControlName="clientSecret"
          placeholder="Enter client secret"
        />
        <mat-error *ngIf="form.controls['clientSecret'].hasError('required')">
          Client secret is required.
        </mat-error>
        <mat-error *ngIf="form.controls['clientSecret'].hasError('maxlength')">
          Client secret must not exceed 10,000 characters.
        </mat-error>
      </mat-form-field>
    </div>

    <app-response-banner
      [success]="successfulSave"
      [successMessage]="successMessage"
      [errorMessage]="errorMessage"
      [invisible]="!showResponseBanner"
    ></app-response-banner>

    <div class="button-box half-width">
      <app-button [title]="'Cancel'" (click)="cancel()"></app-button>
      <app-button
        [tall]="true"
        [title]="isEditMode ? 'Update Credential' : 'Create Credential'"
        [disabled]="form.invalid || saving"
      ></app-button>
    </div>
  </form>
</div>
